import isPickOptionValid from './validation/pick-option';
export default function filterPickerList(options) {
    return options.filter((element) => isPickOptionValid(element));
}
